export const fillArrayToLength = (array, limit) => (array.length
  ? Array(limit).fill().map((_, i) => array[i % array.length])
  : []);
